import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import IsUndefinedNullOrEmpty from '../Common/Validations/valueCheck';
import Alert from 'react-s-alert';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import { CallBackAlert } from '../Common/Validations/validation';
import FailureAlert from '../Common/Failure';

const AboutInfo = {
    SLNo: 0,
    Heading: "",
    Content: ""
}

const BusinessDetails = ({ themeColor, hidebusinessDetails, SaveBusinessDetails, edit, allAbout }) => {

    const [About, setAbout] = useState([]);
    const [AboutContent, setAboutContent] = useState(AboutInfo);
    const [SelectedforEdit, setSelectedforEdit] = useState(-1);
    const [SelectedGallery, setSelectedGallery] = useState(null);

    useEffect(() => {
        if (allAbout && allAbout.Organization && allAbout.Organization.length > 0
            && allAbout.Organization[0].AboutInfo && allAbout.Organization[0].AboutInfo.length > 0) {
            setAbout(allAbout.Organization[0].AboutInfo);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onTextChange = (e) => {
        setAboutContent({ ...AboutContent, [e.target.name]: e.target.value });
    }

    const OnAboutUpdate = () => {
        var error = false;
        if (SelectedforEdit !== -1) {
            let array = [...About];
            if (!IsUndefinedNullOrEmpty(AboutContent.Heading) && !IsUndefinedNullOrEmpty(AboutContent.Content)) {
                array[SelectedforEdit - 1].Heading = AboutContent.Heading;
                array[SelectedforEdit - 1].Content = AboutContent.Content;

                setAbout(array);
                setAboutContent(AboutInfo);
                setSelectedforEdit(-1);
            }
            else {
                error = true;
            }
        }
        else {
            var NewAboutInfo = {
                SLNo: About.length + 1,
                Heading: AboutContent.Heading,
                Content: AboutContent.Content
            };
            if (!IsUndefinedNullOrEmpty(NewAboutInfo.Heading) && !IsUndefinedNullOrEmpty(NewAboutInfo.Content)) {
                setAbout([...About, NewAboutInfo]);
                setAboutContent(AboutInfo);
                setSelectedforEdit(-1);
            }
            else {
                error = true;
            }
        }

        if (error) {
            Alert.error("All fields are mandatory.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnRemoveAbout = (slNo) => {
        let updatedItem = About.filter(a => a.SLNo !== slNo);
        setAbout(updatedItem);
    };

    const OnEditAbout = (indexItem) => {
        let updatedItem = About.filter(a => a.SLNo === indexItem);
        if (updatedItem.length > 0) {
            setAboutContent(updatedItem[0]);
            setSelectedforEdit(indexItem);
        }
    };

    const OnSave = () => {
        let finalAbout = [];
        About.map(about => {
            return finalAbout.push({
                SLNo: about.SLNo,
                Heading: about.Heading.trim(),
                Content: about.Content.trim()
            });
        });

        // if already about info was present was present , then allow to delete complete data
        // if about was never there then dont allow to save till atleast 1 record is added
        if (finalAbout.length > 0 || (allAbout && allAbout.Organization && allAbout.Organization.length > 0 &&
            allAbout.Organization[0].AboutInfo && allAbout.Organization[0].AboutInfo.length > 0)) {
            SaveBusinessDetails(finalAbout);
        }
        else {
            Alert.error("Please add About Info", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnFileUpload = (e) => {
        var files = e.target.files;
        setSelectedGallery(files);
    };

    const OnUploadSubmit = () => {
        if (SelectedGallery && SelectedGallery.length > 0) {
            let formData = new FormData();
            var fileCount = 0;
            var files = SelectedGallery;
            for (var i = 0; i < files.length; i++) {
                if (files[i].type === "image/jpeg" || files[i].type === "image/png" ||
                    files[i].type === "image/jpg") {
                    fileCount++;
                    formData.append('files', files[i]);
                }
            }

            if (fileCount > 0 && allAbout && !IsUndefinedNullOrEmpty(allAbout.Organization &&
                allAbout.Organization.length > 0)) {
                Axiosfetch(baseURL + "UploadBCardFiles/" + allAbout.Organization[0]._id, "POST",
                    formData, UploadBCardFilesSuccess, Failure);
            }
            else {
                Alert.error("File Type allowed are : PNG , JPG, JPEG", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
        }
        else {
            Alert.error("No file Selected for Upload.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    }

    const UploadBCardFilesSuccess = (data) => {
        CallBackAlert(data);
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <div id="addBusinessdetails" className="modal" style={{ display: "block", paddingTop: "40px" }}>
                <div className="modal-content" style={{ width: "75%" }}>
                    <div className={`modal-header header-style align-center ${themeColor}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>{parseInt(edit) === 0 ? "Add" : "Edit"} Business Details</span>
                        <span className="close" onClick={hidebusinessDetails}>&times;</span>
                    </div>
                    <div className="row" style={{
                        margin: "10px", border: "1px solid #ccc", borderRadius: "6px", padding: "5px"
                    }}>
                        <div className="col-md-6" style={{
                            height: "60vh", overflow: "auto",
                        }}>
                            <h4 className="align-center">About Info</h4>
                            {About.length > 0 && About.map(about => (
                                <div key={about.SLNo}>
                                    <div>
                                        <h4><span style={{ padding: "0 10px 0 0" }}>{about.Heading}</span>
                                            <span className="hover-style" style={{
                                                padding: "0 10px 0 10px", color: "red", float: "right",
                                                fontSize: "17px", margin: "auto"
                                            }}
                                                onClick={() => OnRemoveAbout(about.SLNo)}>
                                                <FontAwesomeIcon icon={faTrashAlt} /></span>
                                            <span className="hover-style" style={{ color: "orange", float: "right", fontSize: "17px", margin: "auto" }}
                                                onClick={() => OnEditAbout(about.SLNo)}>
                                                <FontAwesomeIcon icon={faPencilAlt} /></span>

                                        </h4>
                                    </div>
                                    <span>{about.Content}</span>
                                </div>
                            ))}
                            {About.length === 0 && (<div className="noData">No About Info added</div>)}
                        </div>
                        <div className="col-md-6" style={{
                            height: "60vh", overflow: "auto",
                        }}>
                            <div className="text-field">
                                <input name="Heading"
                                    value={AboutContent.Heading} placeholder=""
                                    onChange={(e) => onTextChange(e)}
                                    type="text"></input>
                                <span>Heading Info<span className="mandatoryStar">*</span></span>
                            </div>
                            <div className="text-field">
                                <textarea style={{ resize: "none" }} rows="6" name="Content"
                                    value={AboutContent.Content} placeholder=""
                                    onChange={(e) => onTextChange(e)}
                                    type="text"></textarea>
                                <span>Content<span className="mandatoryStar">*</span></span>
                            </div>
                            <div className="align-right">
                                <button type="button" className="btnStyleWithoutFill" onClick={OnAboutUpdate}>{SelectedforEdit !== -1 ? "Edit" : "Add"}</button>
                            </div>
                            <div style={{ display: "flex", marginTop: "10px", justifyContent: "space-between" }}>
                                <div className="text-field" style={{ margin: "0 10px" }}>
                                    <input type="file" name="Logo" placeholder=""
                                        className="form-control" multiple
                                        onChange={e => OnFileUpload(e)}
                                        accept="image/jpeg, image/jpg, image/png"></input>
                                    <span>Service Gallery (upto 10 images)</span>
                                </div>
                                <div className="align-right">
                                    <button type="button" className="btnStyleWithoutFill" onClick={OnUploadSubmit}>Upload</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 align-right">
                            <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${themeColor}Focus`} onClick={OnSave}>Save</button>
                            <button type="button" className="btn btn-default" onClick={hidebusinessDetails}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BusinessDetails;